import React, {Component} from 'react'
import ParkingPassComponent from '../components/ParkingPassComponent'

export default class PassListScreen extends Component {
    render() {
        const {parkingPasses} = this.props;
        return(
            <div>
                {parkingPasses.length === 0 && <div>Nessun Abbonamento Presente</div>}
                {parkingPasses.map(
                    pp => <ParkingPassComponent key={pp.id} parkingPass={pp}/>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/PassListScreen.js